<template>
  <div class="approval-detail-view">
    <section class="detail-comment">
      <div class="inner-box">
        <div class="comment-left">
          <user-card
            v-if="type !== 'channel'"
            :obj="{
              avatar: initiateObj.avatar,
              name: initiateObj.promoterName,
              job: initiateObj.promoterOrgChain,
              userId: initiateObj.promoterId
            }"
          >
            <template #reward>
              <span class="proposer" v-if="initiateObj.processState === 6"
                >提案人</span
              >
            </template>
            <template #status>
              <div class="status-box">
                <span class="num">NO.{{ initiateObj.contributeCode || '暂无' }}</span>
                <div>
                  <span class="status" :class="`status-${initiateObj.processState}`">{{
                    initiateObj.processStateName
                      | formateProcessState(initiateObj.approverName, initiateObj.processState)
                  }}</span>
                  <span class="instructions" @click="showDialog = true">审批说明</span>
                </div>
              </div>
            </template>
          </user-card>
          <user-card
            v-if="initiateObj.processState === 6 && type !== 'channel' && selectCompanyId == '10001'"
            :obj="{
              avatar: initiateObj.beneficiaryAvatar,
              name: initiateObj.beneficiaryName,
              job: initiateObj.beneficiaryOrgName,
              userId: initiateObj.beneficiaryId
            }"
            style="border-top: 1px solid #eeeeee;"
          >
            <template #reward>
              <span class="reward" v-if="initiateObj.processState === 6"
                >奖励{{ initiateObj.finalScore || 0 }}分</span
              >
            </template>
          </user-card>
          <div class="list-code" v-if="type === 'channel'">
            <span class="num">NO.{{ initiateObj.contributeCode || '暂无' }}</span>
          </div>
          <div class="item-box">
            <div
              class="application"
              v-for="(item, indexC) in formSelList"
              :key="indexC"
              v-show="item.code"
            >
              <div class="title">{{ item.title }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>
          <div class="form-box">
            <div class="item" v-for="(item, index) in formList" :key="index" v-show="item.code">
              <div class="title">{{ item.title }}</div>
              <p class="value">{{ item.value }}</p>
            </div>
          </div>
          <div class="file-box" v-if="fileList.length > 0">
            <div class="file-title">{{ fileObj.title || '上传文件' }}</div>
            <tojoy-file
              class="file-item"
              v-for="(file, index) in fileList"
              :key="index"
              :data="{
                type: file.fileSuffix,
                fileName: file.fileName || '暂无',
                url: file.filePath
              }"
            />
          </div>
        </div>
        <div class="comment-right" v-if="type !== 'channel'">
          <div class="title">
            流程记录
          </div>
          <record-list :list="activities" :score="score" />
        </div>
      </div>
    </section>
    <div
      class="result-bottom"
      v-if="type === 'initiate' || (type === 'approval' && initiateObj.isOpen)"
    >
      <!-- 审批中4  已撤回2 已驳回5  审批通过6 -->
      <el-button
        :class="item.className"
        :type="item.type"
        @click="item.fn(item.code)"
        v-show="item.show"
        v-for="(item, index) in btnConfig"
        :key="index"
        >{{ item.text }}</el-button
      >
    </div>
    <!-- 审批说明弹框 -->
    <approvalExplanation :showDialog="showDialog" modelTyle="team" />
    <!-- 通过 -->
    <pass :showDialog="showPassDialog" :passObj="passObj" :moduleName="moduleName" />
    <!-- 委托他人 -->
    <entrust :showDialog="showEntrustDialog" :entrustObj="entrustObj" :moduleName="moduleName" />
    <!-- 驳回 -->
    <rejected :showDialog="showRejectedDialog" :rejectObj="rejectObj" :moduleName="moduleName" />
  </div>
</template>

<script>
import {
  getInnovationDetail,
  getInnovationDetailProcess,
  postProcessRevoke,
  postInnovationDelete
} from '@/api/api_team'
import detailMixin from '@/mixins/initiate/detailMixin.js'
import { MessageBox, Message } from 'element-ui'
export default {
  name: 'approval-detail',
  mixins: [detailMixin],
  data() {
    return {
      selectCompanyId: localStorage.getItem("selectCompanyId"),
      formSelList: [
        {
          title: '实施单位',
          cname: 'implementOrgName',
          value: '',
          code: null
        },
        {
          title: '提案类别',
          cname: 'contributeCategoryName',
          value: '',
          code: null
        },
        {
          title: '提案日期',
          cname: 'proposalDate',
          value: '',
          code: null
        },
        {
          title: '提案受益人',
          cname: 'beneficiaryName',
          value: '',
          code: null
        }
      ],
      formList: [
        {
          title: '标题',
          cname: 'title',
          value: '',
          code: null
        },
        {
          title: '要点',
          cname: 'gist',
          value: '',
          code: null
        },
        {
          title: '目前现状',
          cname: 'currentSituation',
          value: '',
          code: null
        },
        {
          title: '创新具体成果',
          cname: 'contributeContent',
          value: '',
          code: null
        },
        {
          title: '实施步骤',
          cname: 'implementContent',
          value: '',
          code: null
        },
        {
          title: '预测取得效果',
          cname: 'forecastResult',
          value: '',
          code: null
        }
      ]
    }
  },
  async created() {
    await this.handleDetail()
    this.initBtn()
    this.handleprocessList()
  },
  beforeRouteEnter(to, from, next) {
    to.meta.title = to.query.name ?? sessionStorage.getItem('name') + '提案审批'
    next()
  },
  methods: {
    /**
     * 详情
     */
    async handleDetail() {
      let params = {
        contributeCode: this.id
      }
      await getInnovationDetail(params)
        .then(res => {
          if (res.data) {
            //用户信息从哪里取？？？
            //processState 流程状态
            //approver 当前审批人
            this.initiateObj = res.data
            let {
              beneficiaryCode,
              beneficiaryName,
              contributeLevelName,
              implementOrgName,
              contributeCategoryName,
              proposalDate,
              reportObject,
              title,
              gist,
              currentSituation,
              implementContent,
              forecastResult,
              contributeAnnexList,
              contributeContent,
              contributeAnnexListFormCode,
              contributeAnnexListFormName
            } = res.data
            let obj = {
              title,
              gist,
              currentSituation,
              implementContent,
              forecastResult,
              contributeContent
            }

            let selObj = {
              contributeLevelName,
              implementOrgName,
              contributeCategoryName,
              proposalDate,
              reportObject,
              beneficiaryName,
              beneficiaryCode
            }
            this.handlesetDetail(obj, selObj)
            this.$set(this.fileObj, 'code', contributeAnnexListFormCode)
            this.$set(this.fileObj, 'title', contributeAnnexListFormName)
            this.fileList = contributeAnnexList
          } else {
            this.initiateObj = {}
            if (res.code === '000015' || res.code === '000500') {
              setTimeout(() => {
                this.$router.push({
                  name: 'team-channel'
                })
              }, 700)
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    /**
     * 流程记录
     */
    handleprocessList() {
      getInnovationDetailProcess({ contributeCode: this.id })
        .then(res => {
          let { contributeProcessOperateLogOutputList, finalScoreStr, finalScore } = res.data

          this.activities = contributeProcessOperateLogOutputList
          this.handleSetProcesData(finalScoreStr, finalScore)
        })
        .catch(err => {})
    },
    handleDialog(code) {
      //审批状态 5 驳回  reject  4通过pass
      this.handleSetDialog(
        code,
        this.initiateObj.contributeCategoryName,
        this.initiateObj.contributeCategory
      )
    },
    /**
     * 撤回
     */
    handleRevoke() {
      this.handleRevokeFn({ contributeCode: this.id }, postProcessRevoke, 'team-initiate')
    },
    /**
     * 删除
     */
    handleDelete() {
      this.handleDeleteFn({ contributeCode: this.id }, postInnovationDelete, 'team-initiate')
    },
    /**
     * 撤回 删除确认框
     * type  invoke 撤回  delete 删除
     */
    handleMessageBox(type) {
      let text = type === 'delete' ? '删除' : '撤回'
      MessageBox.confirm(`确定${text}此团队贡献提案吗？`, '提示', {
        confirmButtonText: `确定${text}`,
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (type === 'revoke') {
            this.handleRevoke()
          } else {
            this.handleDelete()
          }
        })
        .catch(() => {
          Message.info(`已取消操作`)
        })
    },
    initBtn() {
      this.initBtnFn(this.handleMessageBox, this.handleEdit, this.handleDialog)
    },
    handleEdit() {
      this.handleEditFn('team-initiateProposal')
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/initiate.scss';
</style>
